import { useEffect, useMemo } from 'react';
import Cookies from 'universal-cookie';
import { useLocation } from 'react-router-dom';

const COOKIE_NAME = '_dgo_merchant_referrer';

export default function useMerchantReferrerCookie() {
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get('ref')) {
      const referrer = String(queryParams.get('ref'));
      const decryptedReferrer = atob(referrer);
      const referrerParams = decryptedReferrer.split(':');
      if (referrerParams.length === 2) {
        const [_, mid] = referrerParams;
        const cookies = new Cookies();
        const domain = import.meta.env.REACT_APP_API_DOMAIN_DLGO;
        const cookieDomain = `.${domain.split('.').slice(1).join('.').replace('/', '')}`;
        console.log('cookieDomain: ', cookieDomain);

        cookies.set(COOKIE_NAME, mid, {
          expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
          path: '/',
          domain: cookieDomain,
        });
      }
    }
  }, []);

  return useMemo(() => {
    const cookies = new Cookies();

    return cookies.get(COOKIE_NAME);
  }, []);
}
